export const urlForAllInstructions = (
    baseUrl: string,
    materialNumber: string,
    online: boolean,
    cbDocType: CB_DOCTYPE,
): string => {
    const accesstype = online ? 'online' : 'download';
    return `${baseUrl}cb-doc/?sysivk=${materialNumber}&cbdoctype=${cbDocType}&accesstype=${accesstype}`;
};

export enum CB_DOCTYPE {
    INSTALLATION = 'installation', // only for installation instructions
    STANDARD = 'standard', // used for all instructions
    BIOMED = 'biomed', // used for biomedical instruction
}
